import { Injectable } from '@angular/core';
import { ServerApi } from '@services/server-api';
import { StorageManager } from '@services/storage-manager.service';
import { getAccountUrl } from '@lib/environments.const';

const ACCOUNT_URL = getAccountUrl();

@Injectable({
  providedIn: 'root',
})
export class LogoutBroadcastChannelService {

  constructor (
    private serverAPI: ServerApi,
    private storageManager: StorageManager,
  ) {}

  public initLogoutBroadcastChannel(): void {
    localStorage.removeItem('session-state-change');
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'session-state-change' && event.newValue !== null) {
        this.handleLogout();
      }
    });
  }

  public emitLogoutEventToAllTabs(): void {
    localStorage.setItem('session-state-change', new Date().toString());
  }

  private handleLogout(): void {
    this.serverAPI.get('sessions/validate').subscribe();
    this.storageManager.clearLocalStorage().then(() => window.location.href = `${ACCOUNT_URL}/sign_out`);
  }
}
